import { PaginationOption } from '@models';
import { searchService } from '@services';
import { BaseComponent } from '../base.component';
import defaultHtml from './page-size.component.hbs';

export class PageSizeComponent extends BaseComponent<Array<PaginationOption>> {
    protected override bindEvent = 'hawksearch:bind-page-size';
    protected override customTemplatePropertyName = 'pageSize';
    protected override defaultHtml = defaultHtml;

    protected getContentHtml(template: HandlebarsTemplateDelegate): string {
        if (!this.data?.length) {
            return '';
        }

        const html = template({
            options: this.data
        });

        return html;
    }

    protected bindChildElements(): void {
        this.shadowRoot?.querySelectorAll('[hawksearch-page-size]').forEach((e) => {
            e.addEventListener('change', (event: Event) => {
                event.preventDefault();

                const element = event.currentTarget as HTMLSelectElement;
                const pageSize = parseInt(element.value);

                searchService.setPageSize(pageSize);
            });
        });
    }
}
